import { Component, Inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { ConfirmDeclarerHasNoneOfTricksDialogModel } from './confirm-declarer-has-none-of-tricks-dialog.model'
import { PlayingGameService } from 'game-services'

@Component({
  selector: 'confirm-declarer-has-none-of-tricks-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './confirm-declarer-has-none-of-tricks-dialog.component.html',
  styleUrls: ['./confirm-declarer-has-none-of-tricks-dialog.component.scss'],
})
export class ConfirmDeclarerHasNoneOfTricksDialogComponent {
  public title = $localize`:ConfirmDeclarerHasNoneOfTricksDialogComponent|Title:${this.model.declarerUsername}, claims they would not pick up any more tricks.`
  public agreeLabel = $localize`:ConfirmDeclarerHasNoneOfTricksDialogComponent|AgreeLabel:Agree`
  public disagreeLabel = $localize`:ConfirmDeclarerHasNoneOfTricksDialogComponent|DisagreeLabel:Disagree`

  public constructor(
    private readonly dialogRef: MatDialogRef<ConfirmDeclarerHasNoneOfTricksDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    private readonly model: ConfirmDeclarerHasNoneOfTricksDialogModel,
    private readonly playingGameService: PlayingGameService,
  ) {}

  public async onRespond(hasAgreed: boolean): Promise<void> {
    await this.playingGameService.respondToDeclarerHasNoneOfTricks(
      this.model.gamePlayGameId,
      hasAgreed,
    )

    this.dialogRef.close()
  }
}
